import { Fragment, useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { PanelControls } from '~/components/ui/PanelControls';
import { ShopContainer } from '~/components/ui/Shop';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { Text } from '~/components/ui/Text';
import { useInputAction } from '~/rage';
import { InputAction, InputKey, WalletType } from '~/shared';
import { AppearanceTab } from '../../components/AppearanceTab';
import { DNATab } from '../../components/DNATab';
import { FinishEdit } from '../../components/FinishEdit';
import { Head } from '../../components/Head';
import { useSaveCharacter } from '../../hooks';
import {
	setTabIndexNext,
	setTabIndexPrev,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledPanelControlsContainer,
	StyledRightContainer,
	StyledStepButtons,
} from './CharacterEditor.styled';

const tabs = [DNATab, AppearanceTab];

const CharacterEditor: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const tabIndex = useLayoutSelector((state) => state.characterEditor.tabIndex);
	const maxTabIndex = useLayoutSelector(
		(state) => state.characterEditor.maxTabIndex,
	);
	const { handleUpdate } = useSaveCharacter();

	const ActiveTab = tabs[tabIndex];

	useInputAction(InputAction.CommonMenuNavLeft, () => {
		dispatch(setTabIndexPrev());
	});
	useInputAction(InputAction.CommonMenuNavRight, () => {
		dispatch(setTabIndexNext());
	});
	useInputAction(InputAction.CommonMenuClose, () => {
		// @TODO
		// rage.characterEditor.exit();
	});

	const controlsUpdate = useMemo(
		() => [
			{
				text: 'Оплатить',
				keys: [InputKey.Enter],
				onClick: () => handleUpdate(WalletType.Cash),
			},
		],
		[handleUpdate],
	);

	const leftControls = [
		{
			text: 'Управление',
			keys: [InputKey.ArrowLeft, InputKey.ArrowRight],
		},
		...controlsUpdate,
		{
			text: 'Крутить камеру',
			keys: [InputKey.MouseRight],
		},
		{
			text: 'Крутить голову',
			keys: [InputKey.MouseLeft],
		},
	];

	const rightControls = [
		{
			text: 'Выйти',
			keys: ['Esc'],
			// @TODO
			onClick: () => {},
			// onClick: () => rage.characterEditor.exit(),
		},
	];

	// @TODO
	// useEffectOnce(() => {
	// 	const newFaceMorphValues = faceMorphConfigs.map((item) => ({
	// 		index: item.index,
	// 		value: 0,
	// 	}));

	// 	dispatch(setFaceMorphValues(newFaceMorphValues));
	// 	rage.characterEditor.setFaceMorphValues(newFaceMorphValues);
	// });

	useEffectOnce(() => {
		// Перетаскивание
		const handleDragging = (e: any) => {
			e.preventDefault();
		};
		document.addEventListener('dragstart', handleDragging);
		return () => document.removeEventListener('dragstart', handleDragging);
	});

	return (
		<Fragment>
			<ShopContainer>
				<Head />
				<ActiveTab />
				<StyledStepButtons
					$buttonCount={tabIndex === 0 || tabIndex === maxTabIndex ? 1 : 2}
				>
					{tabIndex > 0 && (
						<Button
							color={ButtonColors.Default}
							height={ButtonHeight.Height50}
							onClick={() => dispatch(setTabIndexPrev())}
						>
							<Text>Назад</Text>
						</Button>
					)}
					{tabIndex < maxTabIndex && (
						<Button
							color={ButtonColors.Select}
							height={ButtonHeight.Height50}
							onClick={() => dispatch(setTabIndexNext())}
						>
							<Text>Продолжить</Text>
						</Button>
					)}
				</StyledStepButtons>
			</ShopContainer>
			<StyledRightContainer>
				<ShopBalance walletTypes={[WalletType.Cash]} />
				<CloseButton
					onClick={() => console.log('exit')}
					height={ButtonHeight.Height40}
					iconSize={20}
					// @TODO
					// onClick={() => rage.characterEditor.exit()}
				/>
			</StyledRightContainer>
			<StyledPanelControlsContainer>
				<PanelControls controls={leftControls} />
				<PanelControls controls={rightControls} />
			</StyledPanelControlsContainer>
			<FinishEdit />
		</Fragment>
	);
};

export { CharacterEditor };
